import React from 'react';
import './team.css';

const Team = () => {
    return (
        <div className="team-container">
            <h1 className="team-header">Про нас</h1>
            <div className="team-content">
                <div className="team-logo">TechnoVikings</div>
                <div className="team-text">
                    <p>Ми команда ентузіастів - TechnoVikings, студенти НУ "Львівська Політехніка".</p>
                    <p>Займаємось розробкою продукту автоматизованого розблокування дверей з метою покращити доступність до укриттів.</p>
                </div>
            </div>
        </div>
    );
}

export default Team;
